<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input ttLabel="businesssite_keyno" [(ttModel)]="edit.businesssite_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="businesssite_name" [(ttModel)]="edit.businesssite_name"></tt-input>
        <tt-select ttLabel="businessco" [(ttModel)]="edit.businessco_no" [ttData]="selectListBusinessCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-button-save ttText="businesssite_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListStockPlaces"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="businesssite_keyno" tt-model="vm.model.edit.businesssite_keyno" tt-change="vm.model.edit.businesssite_keyno = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="businesssite_name" tt-model="vm.model.edit.businesssite_name" tt-change="vm.model.edit.businesssite_name = $value" tt-placeholder=""></tt-input>
        <tt-select class="col-xs-12 sp-0" tt-label="businessco" tt-model="vm.model.edit.businessco_no" tt-change="vm.model.edit.businessco_no = $value" tt-data="vm.model.selectListBusinessCompanies" tt-data-id="businessco_no" tt-data-name="company_name"></tt-select>
        <tt-button-save class="col-xs-12 sp-0" tt-text="businesssite_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListStockPlaces" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
